import React, { useState } from 'react';
import { HiCalendar, HiX } from 'react-icons/hi';
import Logo from '../common/Logo';

const GoogleCalendarSettings = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="card p-6 mb-4">
        <h2 className="font-bold text-ink-900 flex items-center gap-2.5 text-[0.9375rem] mb-4">
          <div className="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center">
            <HiCalendar className="text-blue-500 text-sm" />
          </div>
          Google Calendar
        </h2>
        <p className="text-sm text-ink-500 mb-4">
          Sync your custody schedule and activities to your personal Google Calendar so everything stays in one place.
        </p>
        <button
          onClick={() => setShowModal(true)}
          className="btn-primary text-sm flex items-center gap-2"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Connect Google Calendar
        </button>
      </div>

      {/* Coming Soon Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content max-w-sm text-center" onClick={e => e.stopPropagation()}>
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 w-8 h-8 rounded-lg flex items-center justify-center text-ink-300 hover:bg-surface-100 hover:text-ink-500 transition-colors"
            >
              <HiX className="text-lg" />
            </button>

            <div className="flex justify-center mb-4 pt-2">
              <Logo size={48} />
            </div>
            <h3 className="text-lg font-bold text-ink-900 font-display mb-2">
              Feature Coming Soon
            </h3>
            <p className="text-sm text-ink-500 mb-6 leading-relaxed">
              Google Calendar sync is on its way. We're working hard to bring this to you — stay tuned!
            </p>
            <button
              onClick={() => setShowModal(false)}
              className="btn-primary w-full"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default GoogleCalendarSettings;
